import styled, { keyframes } from 'styled-components';

export const showIn = keyframes`
  from {
    bottom: -100%;
  } to {
    bottom: 0;
  }
`;

export const StyledSnackbar = styled.div`
  position: fixed;
  padding: 15px 15px 15px 15px;
  text-align: center;
  bottom: 0;
  left: 0;
  right: 0;
  top: auto;
  background: #3a3a3a;
  color: #fff;
  line-height: 20px;
  font-size: 14px;
  animation: ${showIn} 225ms cubic-bezier(0, 0, 0.2, 1);
  transition: all 225ms cubic-bezier(0, 0, 0.2, 1);
  z-index: 1202;

  @media (min-width: 600px) {
    right: 12px;
    bottom: 12px;
    left: auto;
    padding: 16px 24px;
    border-radius: 4px;
    max-width: 300px;
  }
`;
